var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"custom-heading-2"},[_vm._v("Nové objekty")]),_c('apexchart',{attrs:{"width":"100%","height":"350","type":"area","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }